(function () {
    'use strict';

    angular
        .module('news')
        .config(NewsRoute);

    NewsRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function NewsRoute($stateProvider) {
        $stateProvider
            .state('root.news', {
                abstract: true,
                url: '/news',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.news.create', {
                url: '/create',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/news/create/create.html',
                        controller: 'NewsCreateController',
                        controllerAs: 'newsCreateController'
                    }
                }
            })
            .state ('root.news.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/news/list/list.html',
                        controller: 'NewsListController',
                        controllerAs: 'newsListController'
                    }
                }
            })
            .state ('root.news.view', {
                url: '/view/:id',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/news/view/view.html',
                        controller: 'NewsViewController',
                        controllerAs: 'newsViewController'
                    }
                }
            })
            .state ('root.news.edit', {
                url: '/edit/:id',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/news/edit/edit.html',
                        controller: 'NewsEditController',
                        controllerAs: 'newsEditController'
                    }
                }
            })
            .state ('root.news.delete', {
                url: '/delete/:id',
                views: {
                    'inner-view@root': {
                        controller: 'NewsListController',
                        controllerAs: 'NewsListController'
                    }
                }
            });
    }
})();